// Function to sort the array by startDate in descending order
const sortObjectsByStartDateDescending = <T extends { startDate: string }>(arr: T[]) => {
  return arr.sort((a, b) => {
    return new Date(b.startDate).getTime() - new Date(a.startDate).getTime();
  });
};

export default sortObjectsByStartDateDescending;
